import { AssociationPropertyMetaDataInterface } from "@nts/std/interfaces";
import { Expose } from "@nts/std/serialization";

// Property su cui è implementata una relazione
export class AssociationPropertyMetaData implements AssociationPropertyMetaDataInterface {

    /**
     * Property del modello contenente l'associazione
     */
    @Expose()
    principalPropertyName: string;

    /**
     * Property del modello a cui relazionarsi
     */
    @Expose()
    dependentPropertyName: string;

    constructor(
        principalPropertyName?: string,
        dependentPropertyName?: string,
    ) {
        this.principalPropertyName = principalPropertyName;
        this.dependentPropertyName = dependentPropertyName;
    }
}
